import React from 'react';

// import { gridSize, fontSize, colors, themed } from '@atlaskit/theme';

/**
 * Provide a styled container with fieldset as default.
 *
 */

var FieldGroupWrapper = function FieldGroupWrapper(props) {
  // TODO: Once AK is using styled components 2+ the inline styles can be replaced with SCs
  // and setting attributess us styled.fieldset.attrs({})
  var style = {
    display: 'flex',
    flexDirection: props.layout,
    marginTop: '16px'
  };

  return React.createElement(
    'fieldset',
    { style: style },
    props.children,
    React.createElement(
      'legend',
      null,
      props.label
    )
  );
};

export default FieldGroupWrapper;